export const scaleFactor = [
    0.563,
    0.75,
    0.875,
    1,
    1.125,
    1.25,
    1.375,
    1.5,
    2,
    2.25,
    2.5,
    2.75,
    3,
    3.5,
];
export const getScaleFactorObj = () => Object.fromEntries(scaleFactor.map(v => [v, v]));
export const scaleFactorIcons = [
    1,
    1.5,
    2,
];
const getPerc = (scale) => `${scale * 100}%`;
export const scaleMap = {
    '1/2': getPerc(1 / 2),
    '1/3': getPerc(1 / 3),
    '2/3': getPerc(2 / 3),
    '1/4': getPerc(1 / 4),
    '3/4': getPerc(3 / 4),
    '1/5': getPerc(1 / 5),
    '2/5': getPerc(2 / 5),
    '3/5': getPerc(3 / 5),
    '4/5': getPerc(4 / 5),
    '1/6': getPerc(1 / 6),
    '1/7': getPerc(1 / 7),
    full: '100%',
    content: 'auto',
};
